// import axios from "axios"
// import ReactInputMask from "react-input-mask";
import { Button, ButtonGroup } from 'reactstrap';
import LoadScreen from "../UI/LoadScreen";
import { useGetProductQuery, useGetProductParamsQuery } from "../../features/CallApi";
import { useParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';


export const ProductDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { isLoading: productisLoading, data: product, error } = useGetProductQuery(id)
    const { isLoading, data: productParams, refetch: refetchProduct } = useGetProductParamsQuery();

    useEffect(() => { refetchProduct() },
        []
    )

    return (
        <div>
            {productisLoading ? <LoadScreen></LoadScreen> : <div>
                {product && product.length > 0 ? <h1>{error}</h1> : <div>
                    {isLoading ? <LoadScreen /> :
                        <div className="row">
                            <div className="col-xl">
                                <div className="mb-1">
                                    <label htmlFor="categoryId" className="form-label">Категория</label>
                                    <select disabled id="categoryId" name="categoryId" defaultValue={product.category.id} className="form-select" placeholder={`Выберите категорию`}>
                                        {productParams.category ?
                                            productParams.category.map(category =>
                                                <option key={category.id} value={category.id}>{category.name}</option>
                                            ) : <option disabled>Нет доступных категорий</option>}
                                    </select>
                                </div>
                                <div className="mb-1">
                                    <label htmlFor="agent" className="form-label">Агент</label>
                                    <select disabled id="agentId" name="agentId" defaultValue={(product.agent && product.agent.id)} className="form-select">
                                        <option value="0">--- Агент не выбран ---</option>
                                        {productParams.agent ?
                                            productParams.agent.map(agent =>
                                                <option key={agent.id} value={agent.id}>{agent.name} (ИНН: {agent.tin})</option>
                                            ) : <option disabled>Нет доступных агентов</option>}
                                    </select>
                                </div>
                                <div className="mb-1">
                                    <label htmlFor="name" className="form-label">Наименование</label>
                                    <input disabled id="name" defaultValue={product.name} name="name" className="form-control" />
                                </div>
                                <div className="mb-1">
                                    <label htmlFor="sku" className="form-label">Артикул</label>
                                    <input disabled id="sku" name="sku" className="form-control" defaultValue={product.sku} />
                                </div>
                                <div className="mb-1">
                                    <label htmlFor="price" className="form-label">Цена</label>
                                    <input disabled id="price" defaultValue={product.price} name="price" step={.01} type={"number"} className="form-control" />
                                </div>
                                <div className="row mb-1">
                                    <div className="col-md">
                                        <div className="mb-1">
                                            <label htmlFor="typeProduct" className="form-label">Тип продукта</label>
                                            <select disabled id="typeProduct" defaultValue={product.typeProduct} name="typeProduct" className="form-select">
                                                {productParams.typeProduct ?
                                                    productParams.typeProduct.map(typeProduct =>
                                                        <option key={typeProduct.id} value={typeProduct.id}>{typeProduct.name}</option>
                                                    ) : <option disabled>Нет доступных категорий</option>}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md">
                                        <div className="mb-1">
                                            <label htmlFor="taxProduct" className="form-label">Налоговая ставка</label>
                                            <select disabled id="taxProduct" defaultValue={product.taxProduct} name="taxProduct" className="form-select">
                                                {productParams.taxProduct ?
                                                    productParams.taxProduct.map(taxProduct =>
                                                        <option key={taxProduct.id} value={taxProduct.id}>{taxProduct.name}</option>
                                                    ) : <option disabled>Нет доступных категорий</option>}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md">
                                        <div className="mb-1">
                                            <label htmlFor="calculationMethod" className="form-label">Метод расчета</label>
                                            <select disabled id="calculationMethod" defaultValue={product.calculationMethod} name="calculationMethod" className="form-select">
                                                {productParams.calculationMethod ?
                                                    productParams.calculationMethod.map(calculationMethod =>
                                                        <option key={calculationMethod.id} value={calculationMethod.id}>{calculationMethod.name}</option>
                                                    ) : <option disabled>Нет доступных категорий</option>}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-2 d-flex">
                                    <div className=" form-check form-switch">
                                        <label className="form-check-label">Отключен</label>
                                        <input disabled defaultChecked={product.inActive} type="checkbox" className="form-check-input check-input-lc" />
                                    </div>
                                </div>
                                <div className="mb-2 d-flex">
                                    <div className=" form-check form-switch">
                                        <label className="form-check-label">Требует серийный номер</label>
                                        <input disabled defaultChecked={product.requiredSN} type="checkbox" className="form-check-input check-input-lc" />
                                    </div>
                                </div>
                                <div className={`mb-1 ${product.requiredSN ? "" : "d-none"}`}>
                                    <label htmlFor="maskSN" className="form-label">Маска серийного номера</label>
                                    <input disabled defaultValue={product.maskSN} id="maskSN" name="maskSN" type="text" className="form-control" />
                                </div>
                            </div>
                            <div className="col-xl">
                                <label htmlFor="image" className="form-label">Изображение продукта</label>
                                <div className="card mb-3">
                                    <div className="mb-3 text-center">
                                        <img src={product.imageType ? `/api/products/photo/${product.id}` : `/Content/img/NoPhoto.png`} className="img-fluid" alt="Product photo" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <ButtonGroup className='mt-3'>
                        <Button color="warning" onClick={() => navigate(`/admin/products/edit/${id}`)}>
                            Редактировать
                        </Button>
                        <Button color="success" onClick={() => navigate('/admin/products')}>
                            Назад
                        </Button>
                    </ButtonGroup>
                </div>
                }
            </div>}
        </div>
    )
}